type ChampionBeltProps = {
    size?: number;
    title?: string;
};

const ChampionBelt = ({
    size = 22,
    title = "Reigning champion",
}: ChampionBeltProps) => (
    <svg
        width={size * 1.6}
        height={size}
        viewBox="0 0 32 20"
        fill="none"
        style={{
            flexShrink: 0,
            filter: "drop-shadow(0 1px 1.5px rgba(120,70,10,0.25))",
        }}
        role="img"
        aria-label={title}
    >
        <title>{title}</title>
        <rect x="0.5" y="6.5" width="10" height="7" rx="1.2" fill="#5C3A14" stroke="#3F2509" strokeWidth="0.6" />
        <rect x="2" y="8" width="7" height="1" fill="#7A4E1E" />
        <rect x="2" y="11" width="7" height="1" fill="#7A4E1E" />
        <rect x="21.5" y="6.5" width="10" height="7" rx="1.2" fill="#5C3A14" stroke="#3F2509" strokeWidth="0.6" />
        <rect x="23" y="8" width="7" height="1" fill="#7A4E1E" />
        <rect x="23" y="11" width="7" height="1" fill="#7A4E1E" />
        <circle cx="16" cy="10" r="9" fill="#E8A52C" stroke="#8A5410" strokeWidth="0.7" />
        <circle cx="16" cy="10" r="7.2" fill="#FFD66B" stroke="#B8801A" strokeWidth="0.4" />
        <path
            d="M16 5.4l1.35 2.74 3.02.44-2.18 2.13.51 3.0L16 12.3l-2.7 1.42.51-3-2.18-2.13 3.02-.44L16 5.4z"
            fill="#8A5410"
        />
    </svg>
);

export default ChampionBelt;
